import countWords from './countWords'
import { helpers } from 'vuelidate/lib/validators'
import IBAN from 'iban'

/**
 * Validate BIC format (not if BIC itself is valid)
 * @param {string} value BIC value
 * @returns {Boolean} Valid bic format
 */
export function bic (value) {
  return !helpers.req(value) || /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(value)
}

/**
 * Validate IBAN
 * @param {string} value IBAN value
 * @returns {Boolean} IBAN is valid
 */
export function iban (value) {
  return !helpers.req(value) || IBAN.isValid(value)
}

/**
 * Check equality
 * @param {Any} comparison Value to compare to
 */
export function is (comparison) {
  return helpers.withParams(
    { type: 'is', comparison },
    value => !helpers.req(value) || value === comparison
  )
}

/**
 * Validate max number of words
 * @param {number} max Max number of words
 */
export function maxWords (max) {
  return helpers.withParams(
    { type: 'maxWords', max },
    value => !helpers.req(value) || countWords(value) <= max
  )
}

/**
 * Validate password strength according to new security requirements
 * Minimum 12 characters, at least 1 uppercase, 1 lowercase, 1 number, 1 special character
 * @param {string} value Password value
 * @returns {Boolean} Password meets security requirements
 */
export function strongPassword (value) {
  if (!helpers.req(value)) return true
  
  const minLength = value.length >= 12
  const hasUpper = /[A-Z]/.test(value)
  const hasLower = /[a-z]/.test(value)
  const hasNumber = /\d/.test(value)
  const hasSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(value)
  
  return minLength && hasUpper && hasLower && hasNumber && hasSpecial
}

/**
 * Calculate password strength level (0–2)
 * 0: weak, 1: medium, 2: strong
 * @param {string} value Password value
 * @returns {number} Strength level
 */
export function passwordStrength (value) {
  if (!helpers.req(value) || value.length === 0) return 0
  
  let score = 0
  
  if (value.length >= 12) score++
  if (/[A-Z]/.test(value)) score++
  if (/[a-z]/.test(value)) score++
  if (/\d/.test(value)) score++
  if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(value)) score++
  
  if (score <= 2) return 0 // weak
  if (score <= 4) return 1 // medium 
  return 2 // strong
}
